export const ADD_SHOP = 'ADD_SHOP'
export const DELETE_SHOP = 'DELETE_SHOP'
